<template>
	<span>{{ days }}</span>
</template>

<script>
	export default {
		props: ['date'],

		data() {
			return {
				days: ''
			}
		},

		mounted() {
			var a = new Date(this.$props.date.split(' ')[0]);
			var b = new Date();
			var diff = b.getTime() - a.getTime();
			let days = Math.floor(diff/(1000*60*60*24))
			console.log(days);
			switch (days) {
				case 0:
					this.days = 'Hoy';
					break;
				case 1:
					this.days = 'Ayer';
					break;
				default: 
					this.days = days + 'días';
					break;
			}
		}
	}
</script>